import { AssortmentType } from "../../../../commons/types/assortment";
import {
  AssortmentPriceSettings,
  ProductFinderAssortmentFilterSettings,
  Settings
} from "../../../../commons/types/settings";

const assortmentPriceSettings = (settings: Settings): AssortmentPriceSettings => {
  /** NOTE: These are *not* supposed to reflect the default settings. */
  const fallbackSettings: AssortmentPriceSettings = {
    showAssortmentPrices: false,
    showFallbackPrices: false,
    useRrpAsOriginalPrice: false,
    showOriginalPrices: false,
    showSaleBadge: "word"
  };

  const hasAutomaticAssortmentType = settings.assortment.type === AssortmentType.Automatic;

  return hasAutomaticAssortmentType ? settings.assortment.priceSettings : fallbackSettings;
};

const assortmentFilterSettings = (settings: Settings): ProductFinderAssortmentFilterSettings => {
  /** NOTE: These are *not* supposed to reflect the default settings. */
  const fallbackSettings: ProductFinderAssortmentFilterSettings = {
    showAllModelYears: false,
    selectAssortmentAutomatically: false,
    hideAutomaticAssortmentFilter: false,
    showOnlyAvailableVariants: false,
    availabilityFilterVisibility: "dealer_only"
  };

  const hasAnyAssortmentType = Boolean(settings.assortment.type);

  return hasAnyAssortmentType ? settings.assortment.productFinderFilterSettings : fallbackSettings;
};

export default {
  assortmentPriceSettings,
  assortmentFilterSettings
};
